import "./auth.scss";
import { h } from "preact";
import { LoginBox } from "./loginbox";
import { LinkButton, Spacer } from "uitoolkit";
import { useCallback, useState } from "preact/hooks";
import { ForgotPasswordBox } from "./forgotpasswordbox";
import Router, { route } from "preact-router";
import { SignupBox } from "./signupbox";
import { ResetPasswordbox } from "./resetpasswordbox";
import { VerifyEmailbox } from "./verifyemailbox";

export function AuthBox(props: {}) {
    // const [mode, setMode] = useState("login");
    // const navLogin = useCallback(() => setMode("login"), [setMode]);
    // const navForgotPassword = useCallback(() => setMode("forgotpassword"), [setMode]);

    const isLogin = document.location.pathname.toLowerCase().startsWith("/login");

    const onLogin = useCallback(() => {
        route("/");
    }, []);

    return (
        <div class="auth">
            {
                document.location.pathname != "/" && !isLogin &&
                < nav >
                    <LinkButton variant="outline" href="/login" class="authbtn">Log in &gt;</LinkButton>
                </nav>
            }
            <Spacer />
            {
                <Router>
                    <SignupBox path="/signup/:token?" />
                    <ForgotPasswordBox path="/forgotpassword" />
                    <VerifyEmailbox path="/verifyemail/:token" />
                    <ResetPasswordbox path="/resetpassword/:token" />
                    <LoginBox path="/login" onLogin={onLogin} forgotPasswordUrl="/forgotpassword" default />
                </Router>
            }

            <Spacer />
            <footer>
                {
                    // <div className="terms">
                    //     <a href="about:blank" target="_blank">Terms and conditions</a>
                    // </div>
                }
                <div className="info threelines">
                    {
                        //    Additional legal text goes here.<br />
                    }
                    <span>Copyright &copy; 1999-2026 Ontogenesis, all rights reserved.</span>
                </div>
            </footer>
        </div >
    );
}
